// src/hooks/hotelMealPlans/useCreateHotelMealPlan.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createHotelMealPlan } from "../../api/apiHotelMealPlans";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useCreateHotelMealPlan = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createHotelMealPlanFn, isPending } = useMutation({
        mutationFn: createHotelMealPlan,
        onSuccess: (res) => {
            const message = res?.message || "Hotel meal plan created successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelMealPlans"] });
            navigate("/hotel-meal-plans");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to create hotel meal plan");
        },
    });

    return { createHotelMealPlans: createHotelMealPlanFn, isPending };
};

export default useCreateHotelMealPlan;
